import type { ReferenceField } from '@uncinc/react-drupal-core/types';

import type { ProfileDefault } from '../../../types/uncinc_profile/profile';

export default function profileTeamWidgetMapper(profiles: ReferenceField<ProfileDefault>[]) {
  return profiles.map((profile) => profile.entity);
}
